import { useQuery } from '@tanstack/react-query';
import type { UserSearch, UserSearchResponse } from '@metron/shared';
import { toUserSearchParams } from '@metron/shared';
import { useApiClient } from './useApiClient.ts';

/**
 * Runs a Smart Search user spec against `GET /users/filter` (MET-3530).
 * Same caching and previous-page behavior as `useMeterFilter`.
 */
export function useUserFilter(spec: UserSearch | null) {
  const apiClient = useApiClient();
  const params = spec ? toUserSearchParams(spec).toString() : '';

  return useQuery({
    queryKey: ['user-filter', params],
    queryFn: () => apiClient.get<UserSearchResponse>(`users/filter?${params}`),
    enabled: spec !== null,
    placeholderData: (previous) => previous,
  });
}
